import React from "react";
import { Field, TextField, InfoPanel } from "./fields";
import { NavButtons } from "./NavButtons";
import { INTAKE } from "../../constants/testIds";
import { dobError, postcodeError } from "../../lib/validation";

export const Stage3Contact = ({ form, set, platformName, isSocial, onBack, onContinue }) => {
  const c = form.contact || {};
  const setC = (k, v) => set("contact", { ...c, [k]: v });
  const dobErr = dobError(c.dob);
  const postcodeErr = postcodeError(c.address);
  const valid = c.first_name && c.last_name && c.email && c.mobile && c.dob && !dobErr && c.address && !postcodeErr;

  return (
    <div className="space-y-6">
      <h2 className="font-serif text-3xl text-brand-black">
        {isSocial ? "Confirm your details" : "Your contact details"}
      </h2>
      <InfoPanel tone="grey">
        {isSocial
          ? `We received the following details from ${platformName || "our enquiry form"}. Please check and correct them before continuing.`
          : "Please provide your contact details so that we can respond to your enquiry."}
      </InfoPanel>

      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="First name"><TextField value={c.first_name} onChange={(v) => setC("first_name", v)} testid="contact-first-name" /></Field>
        <Field label="Last name"><TextField value={c.last_name} onChange={(v) => setC("last_name", v)} testid="contact-last-name" /></Field>
        <Field label="Email address"><TextField type="email" value={c.email} onChange={(v) => setC("email", v)} testid="contact-email" /></Field>
        <Field label="Mobile number"><TextField value={c.mobile} onChange={(v) => setC("mobile", v)} testid="contact-mobile" /></Field>
      </div>
      <Field label="Postcode" required>
        <TextField value={c.address} onChange={(v) => setC("address", v)} testid="contact-address" />
        {postcodeErr && <p className="text-xs text-brand-danger mt-1" data-testid="contact-address-error">{postcodeErr}</p>}
      </Field>
      <Field label="Date of birth" required>
        <TextField type="date" value={c.dob} onChange={(v) => setC("dob", v)} testid="contact-dob" />
        {dobErr && <p className="text-xs text-brand-danger mt-1" data-testid="contact-dob-error">{dobErr}</p>}
      </Field>

      <p className="text-xs text-muted-foreground">
        Please read our{" "}
        <a href="/privacy" target="_blank" rel="noreferrer" className="text-brand-gold underline underline-offset-2" data-testid="privacy-notice-link">
          privacy notice
        </a>{" "}
        to understand how we handle your information.
      </p>

      <NavButtons onBack={onBack} onNext={onContinue} disabled={!valid} />
    </div>
  );
};
